import { render, staticRenderFns } from "./PublishAffiliatedPanel.vue?vue&type=template&id=fe672c80&scoped=true"
import script from "./PublishAffiliatedPanel.vue?vue&type=script&lang=js"
export * from "./PublishAffiliatedPanel.vue?vue&type=script&lang=js"
import style0 from "./PublishAffiliatedPanel.vue?vue&type=style&index=0&id=fe672c80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe672c80",
  null
  
)

export default component.exports